module.exports = __webpack_public_path__ + "static/media/carta_12.1ed1cfdb.jpg";